import { Modal } from "shared/ui/modal";
import { ModalProps } from "shared/ui/modal/modal";
import { Portal } from "shared/ui/portal";

import { GenerateCertificateContent } from "./content";

type Props = {
  encryptionPubKey: string;
  from: string;
  holderCommitment: string;
} & ModalProps;

export const GenerateCertificateModal = ({
  encryptionPubKey,
  holderCommitment,
  from,
  onClose,
}: Props) => {
  return (
    <Modal onClose={onClose}>
      <Portal>
        <Modal.Overlay>
          <Modal.Content className="w-[400px] px-6 pt-9 pb-6">
            <GenerateCertificateContent
              encryptionPubKey={encryptionPubKey}
              from={from}
              holderCommitment={holderCommitment}
            />
          </Modal.Content>
        </Modal.Overlay>
      </Portal>
    </Modal>
  );
};
